import axiosInstance from '../config/axios';

export const authService = {
  login: (credentials) => axiosInstance.post('/auth/login', credentials),
  logout: () => axiosInstance.post('/auth/logout'),
};

export const vehicleService = {
  getAll:       ()     => axiosInstance.get('/vehicles'),
  getById:      (id)   => axiosInstance.get(`/vehicles/${id}`),
  getTripHistory:(id)  => axiosInstance.get(`/vehicles/${id}/trips`),
  sync:         ()     => axiosInstance.post('/vehicles'),
  createManual: (data) => axiosInstance.post('/vehicles/manual', data),
  getDropdown:  ()     => axiosInstance.get('/vehicles/dropdown'),
};

export const dashboardService = {
  getKPIs: (params) => axiosInstance.get('/dashboard/kpis', { params }),
  getHoursByPOI: (params) => axiosInstance.get('/dashboard/hours-by-poi', { params }),
  getPoiMatrix: (params) => axiosInstance.get('/dashboard/poi-matrix', { params }),
  getEarlyLate: (params) => axiosInstance.get('/dashboard/early-late', { params }),
  getTrends: (params) => axiosInstance.get('/dashboard/trends', { params }),
  getTrips: (params) => axiosInstance.get('/dashboard/trips', { params }),
  getTripDetails: (params) => axiosInstance.get('/dashboard/trip-details', { params }),
  getPoiTeamDashboard: (params) => axiosInstance.get('/dashboard/poi-team', { params }),
};

export const settingsService = {
  get: () => axiosInstance.get('/settings'),
  update: (data) => axiosInstance.put('/settings', data),
};

export const departementService = {
  getAll:   ()         => axiosInstance.get('/departements'),
  getById:  (id)       => axiosInstance.get(`/departements/${id}`),
  create:   (data)     => axiosInstance.post('/departements', data),
  update:   (id, data) => axiosInstance.put(`/departements/${id}`, data),
  delete:   (id)       => axiosInstance.delete(`/departements/${id}`),
};

export const teamService = {
  getAll:   (params)   => axiosInstance.get('/teams', { params }),
  getById:  (id)       => axiosInstance.get(`/teams/${id}`),
  create:   (data)     => axiosInstance.post('/teams', data),
  update:   (id, data) => axiosInstance.put(`/teams/${id}`, data),
  delete:   (id)       => axiosInstance.delete(`/teams/${id}`),
};

export const vehicleTeamService = {
  getAll:  (params)    => axiosInstance.get('/vehicle-teams', { params }),
  create:  (data)      => axiosInstance.post('/vehicle-teams', data),
  update:  (id, data)  => axiosInstance.put(`/vehicle-teams/${id}`, data),
  delete:  (id)        => axiosInstance.delete(`/vehicle-teams/${id}`),
};
